import React from 'react';
import { Tag, Gift, Sparkles } from 'lucide-react';

const Offers = () => {
  const banners = [
    { id: 'b1', title: 'Flat 10% off on first booking', color: 'bg-indigo-50', textColor: 'text-indigo-900' },
    { id: 'b2', title: 'Free pickup on select services', color: 'bg-cyan-50', textColor: 'text-cyan-900' },
    { id: 'b3', title: 'Combo: Wash + Interior detailing', color: 'bg-yellow-50', textColor: 'text-yellow-900' },
  ];

  const deals = [
    { id: 1, title: 'Periodic Service Package', discount: '15% OFF', description: 'Complete car service with oil change' },
    { id: 2, title: 'AC Service Special', discount: '20% OFF', description: 'AC cleaning and gas refill' },
    { id: 3, title: 'Tyre Change Deal', discount: '10% OFF', description: 'On all tyre brands' },
    { id: 4, title: 'Battery Replacement', discount: '12% OFF', description: 'Free installation included' },
  ];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-gray-900">Offers & Deals</h1>
        <p className="text-gray-600 mt-1">Exclusive offers just for you</p>
      </div>

      {/* Banners */}
      <div className="flex space-x-4 overflow-x-auto pb-4">
        {banners.map((banner) => (
          <div
            key={banner.id}
            className={`${banner.color} ${banner.textColor} rounded-xl p-6 min-w-[300px] flex-shrink-0`}
          >
            <div className="flex items-center space-x-2 mb-2">
              <Gift size={24} />
              <h2 className="text-xl font-bold">{banner.title}</h2>
            </div>
            <p className="text-sm opacity-80">T&C apply. Limited time offers.</p>
          </div>
        ))}
      </div>

      {/* Trending Deals */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
        <div className="flex items-center space-x-2 mb-4">
          <Sparkles size={24} className="text-purple-600" />
          <h2 className="text-xl font-bold text-gray-900">Trending Deals</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {deals.map((deal) => (
            <div
              key={deal.id}
              className="p-4 border border-gray-200 rounded-lg hover:shadow-md transition"
            >
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <div className="flex items-center space-x-2 mb-2">
                    <Tag size={20} className="text-green-600" />
                    <h3 className="font-semibold text-gray-900">{deal.title}</h3>
                  </div>
                  <p className="text-sm text-gray-600">{deal.description}</p>
                </div>
                <span className="px-3 py-1 bg-green-100 text-green-700 rounded-lg font-semibold text-sm">
                  {deal.discount}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Offers;

